module.exports = __webpack_public_path__ + "img/neznama.186fec30.svg";